export const data = {
  experience: [
    {
      title: "FrontEnd developer Intern ,",
      subTitle: "Crystal clear Services Pvt Ltd",
      description: "Impementing UI/UX for open source and company site",
      year: "Dec 2023 - April 2024",
    },
    {
      title: "Sde Intern ,",
      subTitle: "PAiGPT Fintech.ai",
      description: "Working on the web app of the company site ",
      year: "May 2024- Present",
    },
  ],
  education: [
    {
      title: "B.Tech",
      subTitle: "IIIT Guwahati",
      description: "Bachelor of technology in computer science",
      percentage: "8.0 CPI",
      year: "2020-2024",
    },

    {
      title: "Higher Secondary",
      subTitle: "Gyan Bhart Residential Complex Gaya Bihar",
      description: "12th Grade in Science",
      percentage: "82%",
      year: "2018-2019",
    },
    {
      title: "Secondary",
      subTitle: "Sec DPS School Gaya Bihar",
      description: "10th Grade",
      percentage: "9.8 CGPA",
      year: "2016-2017",
    },
  ],
};
